import React from 'react';
import styles from './SkuAttribute.module.scss';
import { Props, sizes } from './types';
import { formatString } from './utils';

const SkuAttribute = (props: Props) => {
  const {
    attribute: { value, attributeName, type, name },
    size = sizes.standard
  } = props;

  const formatName = () => {
    return type.toLowerCase().includes('size')
      ? name.toUpperCase()
      : name;
  };

  const isColor = value.startsWith('#');

  return (
    <div className={styles[size]}>
      {formatString(attributeName || type)}
      {isColor
        ? <div className={styles.circle} style={{ background: value }} />
        : ''}
      {formatName()}
    </div>
  );
};

export default SkuAttribute;
